import { combineReducers } from 'redux';
import pricing from './pricing';
import zones from './zones';
import venues from './venues';
import user from './user';
import errorHandler from './errorHandler';
import notes from './notes';
import eventSearch from './event-search';
import notifications from './notifications';
import killshot from './killshot';
import killshotReport from './killshot-report';
import staticLookerDashboard from './static-looker-dashboars';
import thresholdNotifications from './threshold-notification';
import eventDashboardReports from './event-dashboard-report';
import refreshGroupsInventory from './refresh-groups-inventory';
import refreshGroups from './refresh-groups';
import groupsStubhubState from './groupsListings';
import groupsStubhubSeatingState from './groups-stubhubs-seating';
import groups from './groups';
import saleNotifications from './sale-notifications';
import globals from './globals';

const rootReducer = combineReducers({
  pricing,
  zones,
  venues,
  user,
  errorHandler,
  notes,
  eventSearch,
  notifications,
  killshot,
  killshotReport,
  staticLookerDashboard,
  thresholdNotifications,
  eventDashboardReports,
  refreshGroupsInventory,
  refreshGroups,
  groupsStubhubState,
  groupsStubhubSeatingState,
  groups,
  saleNotifications,
  globals,
});

export default rootReducer;
